import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {Log} from '@aboutyou/mlm';
import {FixedRatioContainer, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {useStoryIdFromUrl} from '../utils/useStoryIdFromUrl';
import {StoryHeaderView, StoryHeaderViewProps} from './StoryHeaderView';
import {useGetStoryHeader} from './utils/useGetStoryHeader';

export const StoryHeader: React.FC<StoryHeaderViewProps & PriorityConfig> = ({
  renderingPriority,
  ...props
}) => {
  const storyId = useStoryIdFromUrl();

  return (
    <DataFetcher
      request={useGetStoryHeader()}
      Error={({error}) => {
        Log.error('@aboutyou/logic-components', 'StoryHeader Error', {
          error: error as Error,
          storyId,
        });

        return null;
      }}
      Loading={StoryHeaderLoading}
      View={StoryHeaderView}
      viewProps={props}
      renderingPriority={renderingPriority}
    />
  );
};

const StoryHeaderLoading: React.FC = () => (
  <FixedRatioContainer ratio="1:1">
    <SkeletonBlock $width="100%" $height="100%" />
  </FixedRatioContainer>
);
